import { render, staticRenderFns } from "./SettingPage.vue?vue&type=template&id=4f255f9c&scoped=true"
import script from "./SettingPage.vue?vue&type=script&lang=js"
export * from "./SettingPage.vue?vue&type=script&lang=js"
import style0 from "./SettingPage.vue?vue&type=style&index=0&id=4f255f9c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f255f9c",
  null
  
)

export default component.exports